
import levelingPartner from "@/app/infrastructures/misc/common-library/LevelingPartner";
import { ellipsisString, formatDate } from "@/app/infrastructures/misc/Utils";
import { AccountController } from "@/app/ui/controllers/AccountController";
import { title } from "process";
import { Options, prop, Vue } from "vue-class-component";
import OverlayPanel from "primevue/overlaypanel";

interface MitraData {
  reporter?: {
    partnerCode: string;
    partnerName: string;
    partnerUsername: string;
    partnerTier?: string;
    date: string;
    avatar?: string;
  };
  escalation?: Array<{
    partnerCode: string;
    partnerName: string;
    partnerUsername: string;
    date: string;
    type?: string;
    finishAt: string;
  }>;
  escalationBefore?: Array<{
    partnerCode: string;
    partnerName: string;
    partnerUsername: string;
    date: string;
    type?: string;
    finishAt: string;
  }>;
  agent?: {
    partnerCode: string;
    partnerName: string;
    partnerUsername: string;
    partnerFullname: string;
    date: string;
  };
  followers?: Array<{
    partnerCode: string;
    partnerName: string;
    partnerUsername: string;
    avatar?: string;
  }>;
}

class Props {
  data = prop<MitraData>({ required: true, default: () => ({}) });
  isSummary = prop<boolean>({
    type: Boolean,
    default: false
  });
}

@Options({
  components: {
    OverlayPanel
  }
})
export default class PartnerSection extends Vue.with(Props) {
  get level() {
    return this.data?.reporter?.partnerTier
      ? levelingPartner(this.data.reporter.partnerTier)
      : null;
  }

  ellipsisText(val: string, length: number) {
    return ellipsisString(val, length);
  }
  formatDateTime(date: any): string {
    return formatDate(date);
  }
  showEscalationModal = false;
  yourUsername(username: string) {
    return username.toLowerCase() === AccountController.accountData.username;
  }

  showAllFollowers = false;

  get displayedFollowers() {
    if (!this.data.followers?.length) return [];
    return this.showAllFollowers
      ? this.data.followers
      : this.data.followers.slice(0, 1);
  }

  toggleFollowersList() {
    this.showAllFollowers = !this.showAllFollowers;
  }

  get hasCurrentUser() {
    return (
      this.data.followers?.some((follower) =>
        this.yourUsername(follower.partnerUsername)
      ) ?? false
    );
  }

  get displayedFollowerCount() {
    if (!this.data.followers?.length) return 0;
    return this.hasCurrentUser
      ? this.data.followers.length - 1
      : this.data.followers.length;
  }

  mitraValueByCondition(val: any) {
    return val.partnerUsername
      ? `${val.partnerCode} - ${val.partnerName} - ${val.partnerUsername}`
      : `${val.partnerCode} - ${val.partnerName}`;
  }

  toggleTooltip(event: any, partnerCode: string) {
    const refs: any = this.$refs;
    refs[partnerCode].toggle(event);
  }
}
